import { gql, useMutation } from '@apollo/client';
import { GET_EMPLOYEE_QUESTIONNAIRES_FOR_TABLE } from './get-employee-questionnaires.hook';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_QUESTIONNAIRES_BY_ID } from './get-employee-questionnaire-by-id.hook';

export const ACCEPT_EMPLOYEE_QUESTIONNAIRES = gql`
  mutation acceptEmployeeQuestionnaire($payload: EmployeeQuestionnaireAcceptInput!) {
    acceptEmployeeQuestionnaire(payload: $payload) {
      _id
      applicantId
    }
  }
`;

export const useAcceptEmployeeQuestionnaire = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [acceptEmployeeQuestionnaire] = useMutation(ACCEPT_EMPLOYEE_QUESTIONNAIRES, {
    onCompleted: data => {
      if (onSuccess && data) {
        onSuccess();
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: 'Error',
        description: error?.message || error?.description,
      });
    },
    refetchQueries: [GET_EMPLOYEE_QUESTIONNAIRES_FOR_TABLE, GET_QUESTIONNAIRES_BY_ID],
  });

  return acceptEmployeeQuestionnaire;
};
